<template>
  <el-image v-if="preview" :key="src" style="width: 100%; height: 100%;" :src="url" :fit="fit" :preview-src-list="[url]"> </el-image>
  <el-image v-else :key="src" style="width: 100%; height: 100%;" :src="url" :fit="fit"> </el-image>
</template>
<script>
import { GET_FILE_LINK } from '@/utils/api'
export default {
  name: 'file-image',

  props: {
    src: {
      type: String,
      required: true,
      default: ''
    },
    fit: {
      type: String,
      required: false,
      default: ''
    },
    preview: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data () {
    return {
      url: ''
    }
  },

  watch: {
    src () {
      this.getUrl()
    }
  },

  created () {
    this.getUrl()
  },

  methods: {
    async getUrl () {
      const res = await GET_FILE_LINK(this.src)
      this.url = res.data
    }
  }
}
</script>
